/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentServiceabilityImpl
 * @hideconstructor
 * @classdesc Widget Service Implementation class
 */
define([
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../api/DashboardAPI',
	'../ContentInfoAPI',
	'./ContentInfoImpl',
	'../../../../features/dashboard/dashboardServiceability/view/ServiceabilityContent',
	'react',
	'react-dom'
], (APIFactory,
	DashboardAPI,
	ContentInfoApi,
	ContentInfoImpl,
	ServiceabilityContent,
	React,
	ReactDOM
) => {
	class ContentServiceabilityImpl {
		constructor(options) {
			this.getDashboardAPI = () => { return options.dashboardAPI; };
			this.getContentAPI = () => { return options.content; };
			let logger = options.dashboardAPI.getService(DashboardAPI.GLOBAL_SERVICES.LOGGER);
			this.getLogger = () => {  return logger; };

			this._contentInfo = APIFactory.createAPI(new ContentInfoImpl(this.getContentAPI(), this.getLogger()), [ContentInfoApi]);
			this._contentInfo.setData('generalInfo', {});
			this._isInfoVisible = false;
		}

		getContentInfo() {
			return this._contentInfo;
		}

		isInfoVisible() {
			return this._isInfoVisible;
		}

		/**
		 * @description Currently we only fetch and process the info of Performance section.
		 * But it should be more generic.
		 * @todo `showInfo` will have an argument to indicate what sections we're going to display so
		 * that we don't have to hardcode 'Performance'. Then, we fetch the sections and process them.
		 */
		_fetchUIJSON() {
			return this._contentInfo.toUIJSON({ mode: 'overlay' }).filter((section) => {
				return section.sectionName === 'Performance';
			});
		}

		showInfo() {
			this._isInfoVisible = true;

			let contentViewDOM = this.getContentAPI().getFeature('ContentViewDOM');
			if (contentViewDOM){
				let overlayID = 's12yOverlay_' + this.getContentAPI().getId();
				let contentNode = contentViewDOM.getNode();
				let overlayNode = contentNode.querySelector('#' + overlayID);
				if(!overlayNode){
					overlayNode = document.createElement('div');
					overlayNode.id = overlayID;
					overlayNode.className = 's12yOverlay';
					contentNode.appendChild(overlayNode);
					const UIJson = this._fetchUIJSON();

					let infoNode = <React.Fragment>
						<div className={'s12yOverlayBackground'}/>
						<ServiceabilityContent
							widgetInfo={this._contentInfo}
							dashboardApi={this.getDashboardAPI()}
							UISpec={UIJson}
							showButtons={false}
							header={false}
							isExpanded={true}
						/>
					</React.Fragment>;

					ReactDOM.render(infoNode, overlayNode);
				}
			} else {
				this.getLogger().warn('cannot find ContentViewDOM feature');
			}
		}

		hideInfo() {
			this._isInfoVisible = false;

			let contentViewDOM = this.getContentAPI().getFeature('ContentViewDOM');
			if (contentViewDOM){
				let overlayID = 's12yOverlay_' + this.getContentAPI().getId();
				let contentNode = contentViewDOM.getNode();
				let overlayNode = contentNode.querySelector('#' + overlayID);
				if(overlayNode){
					ReactDOM.unmountComponentAtNode(overlayNode);
					contentNode.removeChild(overlayNode);
				}
			} else {
				this.getLogger().warn('cannot find ContentViewDOM feature');
			}
		}
	}
	return ContentServiceabilityImpl;
});
